export default "__VITE_ASSET__9563f59f__"